import { render } from "./BookmarkContent.vue?vue&type=template&id=f9db2caa"
import script from "./BookmarkContent.vue?vue&type=script&lang=js"
export * from "./BookmarkContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__